import type { RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/application/stores/authStore";
import { useAppStore } from "@/application/stores/app";
import { useClubStore } from "@/application/stores/clubStore";

export default async function authGuard(to: RouteLocationNormalized) {
  const authStore = useAuthStore();
  const appStore = useAppStore();
  const clubStore = useClubStore();

  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    appStore.setRedirectUrl();
    return { name: "auth.login" };
  }

  if (authStore.isLoggedIn && to.name !== "error") {
    await clubStore.ensureLoaded().catch(() => undefined);

    if (clubStore.clubs.length === 0) {
      return { name: "error", params: { errorCode: "no-club" } };
    }
  }

  if (
    authStore.isLoggedIn &&
    appStore.redirectUrl &&
    to.name !== "auth.login"
  ) {
    const redirectUrl = appStore.redirectUrl;
    appStore.clearRedirectUrl();
    if (redirectUrl !== to.fullPath) return redirectUrl;
  }

  if (to.name === "auth.login" && authStore.isLoggedIn) {
    return { name: "home" };
  }

  return true;
}
